import "@/App.css";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Dashboard />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#1a1a1a",
            border: "1px solid #333842",
            color: "#f5f5f5",
            fontFamily: "'Exo', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
